import { skills } from "./skills";

export const projects = [
  {
    slug: "lua-ai",
    name: "Lua AI Agent Platform",
    image: "/assets/projects/lua-ai-0.png",
    description:
      "The Lua AI Agent Platform is an enterprise AI agent OS that enables developers and non-tech users to build, deploy, and scale AI agents with customizable personas, analytics, and skill integrations for automated workflows.",
    details: [
      "Improved agent persona management, reducing setup and onboarding time and increasing adoption",
      "Enhanced backend analytics for AI agents using Node.js and MongoDB, processing daily insights.",
      "Developing Lua AI skill platform, allowing developers to publish skills for AI agent customization.",
    ],
    links: [
      {
        name: "Lua AI",
        url: "https://heylua.ai/",
      },
    ],
    skills: [
      skills.mastraAI,
      skills.nest,
      skills.react,
      skills.typescript,
      skills.jest,
      skills.postgres,
      skills.mongo,
      skills.kubernetes,
    ],
    images: [
      "/assets/projects/lua-ai-1.png",
      "/assets/projects/lua-ai-2.png",
      "/assets/projects/lua-ai-3.png",
      "/assets/projects/lua-ai-4.png",
    ],
    summary: [
      "Contributing to Lua AI Agent Platform, an enterprise OS for building and scaling AI agents",
      "Enhancing full-stack features (Nest.js, React, TypeScript) for agent creation, analytics, and skill integrations",
      "Backend development and DevOps for automation and enterprise deployments.",
    ],
    frontendSummary: [
      "Contributing to Lua AI Agent Platform, an enterprise OS for building and scaling AI agents",
      "Building intuitive UIs with React and TypeScript for non-tech agent creation and analytics dashboards",
      "Enhancing user-facing features for agent personalization and real-time insights",
    ],
    backendSummary: [
      "Contributing to Lua AI Agent Platform, an enterprise OS for building and scaling AI agents",
      "Building backend services with Nest.js, Postgres, MongoDB, and K8s for analytics and skill management",
      "Leading optimizations and DevOps for scalable AI workflows and deployments.",
    ],
  },
  {
    slug: "burq",
    name: "Burq Dashboard",
    image: "/assets/projects/burq-0.png",
    description:
      "The Burq Dashboard is a last-mile delivery solution that empowers merchants with tools for incident reporting, driver management, and real-time analytics, streamlining operations across grocery, retail, and floral industries.",
    details: [
      "Migrated frontend from JavaScript React to TypeScript React with shadcn components, enabling consistent UI and reducing bugs.",
      "Built a full-stack delivery incidents system with React and Node.js, supporting merchants and cutting resolution time from more than 4 hours to less than 1 hour.",
      "Developed a driver management microservice with React, Node.js, and Docker, onboarding 20+ merchants with route optimization.",
      "Led a merchant analytics microservice using Node.js, Snowflake, and DBT, creating fact/dimension tables to reduce query times.",
    ],
    links: [
      {
        name: "Burq Inc",
        url: "https://dashboard.burqup.com/",
      },
    ],
    skills: [
      skills.react,
      skills.typescript,
      skills.node,
      skills.postgres,
      skills.snowflake,
      skills.dbt,
      skills.redis,
    ],
    images: [
      "/assets/projects/burq-0.png",
      "/assets/projects/burq-1.png",
      "/assets/projects/burq-2.png",
      "/assets/projects/burq-3.png",
      "/assets/projects/burq-4.png",
    ],
    summary: [
      "Contributing to Burq Delivery Platform, a last-mile delivery solution for merchants",
      "Building full-stack features (React, TypeScript, Node.js, PostgreSQL) and analytics (Snowflake, DBT)",
      "Leading microservices and contributing to DevOps workflows and automation.",
    ],
    frontendSummary: [
      "Contributing to Burq Delivery Platform, a last-mile delivery solution for merchants",
      "Building responsive UIs with React, TypeScript, and shadcn components",
      "Enhancing merchant-facing features for usability and engagement",
    ],
    backendSummary: [
      "Contributing to Burq Delivery Platform, a last-mile delivery solution for merchants",
      "Building microservices with Node.js, PostgreSQL, and Snowflake",
      "Leading microservices and contributing to DevOps workflows and automation.",
    ],
  },
  {
    slug: "volo-iq",
    name: "Volo IQ",
    image: "/assets/projects/volo.jpeg",
    description:
      "The VoloIQ is the “digital brains” behind eVTOL ecosystem. This cloud-based platform manages everything from VoloCity air taxis to urban integration efforts, and passenger app.",
    details: [
      "Provided support, developed new features, and adhered to test-driven development practices for the ecosystem.",
      "Implemented micro front-ends with React JS to ensure a modular and scalable approach to frontend development, while conducting frontend testing with Cypress.",
      "Leveraged microservices architecture using Node.js to facilitate flexible and efficient backend API endpoint implementation, supported by comprehensive test-driven development methodologies with Jest.",
      "Conducted both frontend and backend pact tests for enhanced reliability and contract testing.",
      "Integrated Kafka messaging tool and socket technology for efficient and real-time communication within the system.",
    ],
    links: [
      {
        name: "Volo IQ",
        url: "https://www.volocopter.com/en/solutions/voloiq",
      },
    ],
    skills: [
      skills.react,
      skills.xState,
      skills.node,
      skills.kafka,
      skills.socket,
      skills.postgres,
      skills.pactTests,
      skills.cypress,
      skills.jest,
    ],
    images: ["/assets/projects/volo.jpeg"],
    summary: [
      "Contributed to Volo IQ, a cloud-based eVTOL ecosystem platform",
      "Built micro front-ends (React, Cypress) and microservices (Node.js, Kafka)",
      "Used test-driven and contract-testing methodologies",
    ],
    frontendSummary: [
      "Contributed to Volo IQ, a cloud-based eVTOL ecosystem platform",
      "Built micro front-ends (React, Cypress)",
      "Used test-driven and contract-testing methodologies",
    ],
    backendSummary: [
      "Contributed to Volo IQ, a cloud-based eVTOL ecosystem platform",
      "Built microservices (Node.js, Kafka)",
      "Used test-driven and contract-testing methodologies",
    ],
  },
  {
    slug: "crypto-exchange",
    name: "Crypto Exchange",
    image: "/assets/projects/cryptox-1.png",
    description:
      "A cryptocurrency exchange platform that allows users to buy, sell, and trade various cryptocurrencies through P2P, Spot and more.",
    details: [
      "Frontend development with React TypeScript, utilizing Redux Toolkit and RTK Query for efficient state management and API calls.",
      "Backend development with Node TypeScript and Express, integrating MongoDB for robust data management.",
      "Implemented multi-factor authentication (MFA) methods including passkey, authenticator, email, and SMS for enhanced security.",
      "Utilized CSRF tokens to prevent cross-site request forgery attacks and ensure application security.",
    ],
    skills: [
      skills.react,
      skills.materialUI,
      skills.mongo,
      skills.node,
      skills.express,
      skills.typescript,
      skills.redux,
      skills.jest,
    ],
    images: [
      "/assets/projects/cryptox-1.png",
      "/assets/projects/cryptox-2.png",
      "/assets/projects/cryptox-3.png",
    ],
    summary: [
      "Developed a secure crypto exchange platform with React, Node.js, and Python",
      "Actively participated in Architecture and Design decisions",
      "Implemented features like KYC, P2P trading, Spot and more",
    ],
    frontendSummary: [
      "Developed a secure crypto exchange platform with React",
      "Actively participated in Architecture and Design decisions",
      "Implemented features like KYC, P2P trading, Spot and more",
    ],
    backendSummary: [
      "Developed a secure crypto exchange platform with Node.js, and Python",
      "Actively participated in Architecture and Design decisions",
      "Implemented features like KYC, P2P trading, Spot and more",
    ],
  },
  {
    slug: "construction-pro",
    name: "Construction Pro",
    image: "/assets/projects/core-1.jpeg",
    description:
      "Construction Pro is a platform that offers team leaders and workers the ability to log their daily time within a highly dynamic and configurable environment.",
    details: [
      "Developed Worker Frontend and Admin Frontend using React.js for Construction Pro platform",
      "Created a dynamic time and shift recording system inspired by Clockify for workers and team leaders",
      "Implemented a backend using Node.js and Express.js, leveraging MongoDB for efficient data storage",
      "Employed advanced Mongo aggregate queries to handle the dynamic nature of the platform",
      "Integrated Socket.IO to enable live notifications, keeping users informed in real-time",
      "Ensured a seamless and user-friendly experience for workers and administrators on the platform",
    ],
    links: [
      {
        name: "Admin Portal",
        url: "https://admin.coreapp.ca/",
      },
      {
        name: "User Portal",
        url: "https://coreapp.ca/",
      },
    ],
    skills: [
      skills.react,
      skills.materialUI,
      skills.node,
      skills.express,
      skills.mongo,
      skills.ec2,
      skills.route53,
      skills.lambda,
      skills.socket,
    ],
    images: [
      "/assets/projects/core-1.jpeg",
      "/assets/projects/core-2.jpeg",
      "/assets/projects/core-3.jpeg",
      "/assets/projects/core-4.jpeg",
      "/assets/projects/core-5.jpeg",
      "/assets/projects/core-6.jpeg",
      "/assets/projects/core-7.jpeg",
    ],
    summary: [
      "Led the development of a dynamic time-tracking and shift management platform with React, Node.js, MongoDB, and Socket.IO",
      "Delivering real-time notifications and an intuitive user experience for workers and admins",
    ],
    frontendSummary: [
      "Led the development of a dynamic time-tracking and shift management platform with React and Socket.IO",
      "Delivering real-time notifications and an intuitive user experience for workers and admins",
    ],
    backendSummary: [
      "Led the development of a dynamic time-tracking and shift management platform with Node.js, MongoDB, and Socket.IO",
      "Delivering real-time notifications and an intuitive user experience for workers and admins",
    ],
  },
  {
    slug: "reverse-marketplace",
    name: "Reverse Marketplace",
    image: "/assets/projects/rm-1.png",
    description:
      "It is a Australian national tendering marketplace connecting Farmers with Suppliers of AgChem, Fertilizer, Fuel, and seed through our unique tendering process.",
    details: [
      "Implemented frontend using React.js with Redux Toolkit and Saga Middleware",
      "Introduced in-app chat feature for farmer-supplier communication",
      "Integrated live notifications for real-time updates",
      "Developed backend with Node.js and MongoDB for robust data management",
      "Deployed the application on an EC2 instance for scalability and accessibility",
    ],
    links: [
      {
        name: "Admin Portal",
        url: "https://admin.iinputs.ca/",
      },
      {
        name: "User Portal",
        url: "https://iinputs.com/",
      },
    ],
    skills: [
      skills.react,
      skills.node,
      skills.express,
      skills.mongo,
      skills.ec2,
      skills.route53,
    ],
    images: [
      "/assets/projects/rm-1.png",
      "/assets/projects/rm-2.png",
      "/assets/projects/rm-3.png",
      "/assets/projects/rm-4.png",
      "/assets/projects/rm-5.png",
    ],
  },
  {
    slug: "ideawake",
    name: "Ideawake",
    image: "/assets/projects/ideawake-1.jpeg",
    description:
      "A cutting-edge platform supporting innovation programs from idea collection to measured results",
    details: [
      "Provided extensive support, fixes, and new features to enhance functionality and user experience of the platform",
      "Front-end development using Angular and Redux to create intuitive and interactive user interfaces for a seamless user experience",
      "Back-end development using NestJS, a powerful and scalable NodeJS framework, to develop robust and efficient APIs",
      "Worked with various technologies and tools, including sockets, Redis, migrations, transactions, video streaming, video conversion using FFMPEG, and ACL (Access Control Lists)",
      "Hone technical skills and expand knowledge in diverse areas of software development through project experiences",
    ],
    links: [
      {
        name: "Link",
        url: "https://ideawake.com/",
      },
    ],
    skills: [
      skills.angular,
      skills.nest,
      skills.postgres,
      skills.ec2,
      skills.lambda,
      skills.cloudwatch,
      skills.elasticBeanstalk,
      skills.elasticSearch,
      skills.redis,
    ],
    images: [
      "/assets/projects/ideawake-1.jpeg",
      "/assets/projects/ideawake-2.jpeg",
      "/assets/projects/ideawake-3.jpeg",
    ],
  },
  {
    slug: "saag",
    name: "Share Adventure and Gear",
    image: "/assets/projects/saag-1.jpeg",
    description: "A dynamic marketplace for renting or lending outdoor gear.",
    details: [
      "Played a pivotal role in designing an attractive UI from scratch using Angular and PrimeNG Library",
      "Integrated Firestore for efficient data storage and retrieval",
      "Developed numerous features to enhance platform functionality, including listings, online payment integration with PayPal, in-app chat, Google Maps integration, and sharing/saving listings",
      "Leveraged technical skills in Angular, UI design, database integration, and payment gateway integration for a smooth user experience",
      "Addressed unique challenges by applying problem-solving skills and collaborating with the team",
    ],
    links: [
      {
        name: "Link",
        url: "https://shareadventureandgear.com/",
      },
    ],
    skills: [skills.angular, skills.firebase, skills.materialUI],
    images: [
      "/assets/projects/saag-1.jpeg",
      "/assets/projects/saag-2.jpeg",
      "/assets/projects/saag-3.jpeg",
    ],
  },
  {
    slug: "bh4h",
    name: "Balanced Healing for Heroes",
    image: "/assets/projects/bh4h-1.jpeg",
    description:
      "Contributed to a meaningful project for a nonprofit organization that offers education, information, and complimentary services to individuals living with PTSD and addiction.",
    details: [
      "Contributed to a meaningful project for a nonprofit organization that offers education, information, and complimentary services to individuals living with PTSD and addiction",
      "Developed the Admin portal and Web portal from scratch, utilizing ReactJS for the front end and NodeJS with MongoDB for the back end",
      "Integrated notifications using Firebase Cloud Messaging (FCM) to enhance user experience and streamline communication",
      "Successfully handled deployment process using AWS EC2 Instance, including setting up and configuring necessary infrastructure for optimal performance and reliability",
    ],
    skills: [
      skills.react,
      skills.bootstrap,
      skills.node,
      skills.express,
      skills.mongo,
      skills.firebase,
      skills.ec2,
      skills.route53,
    ],
    images: [
      "/assets/projects/bh4h-1.jpeg",
      "/assets/projects/bh4h-2.jpeg",
      "/assets/projects/bh4h-3.jpeg",
    ],
  },
  {
    slug: "blutwerte",
    name: "Blutwerte",
    image: "/assets/projects/blutwerte-1.jpeg",
    description:
      "Blutwerte.de aims to enable users to store their laboratory findings in a digitized and organized format. This conversion from analog to digital results in many advantages for the users.",
    details: [
      "Worked on the backend side, providing APIs for the mobile application",
      "Implemented functionality for reading and extracting data from images and PDF files",
      "Also worked on the admin portal using React for seamless management of the platform.",
      "Deployed the application using EC2 instances for efficient and scalable hosting.",
    ],
    links: [
      {
        name: "Link",
        url: "https://www.bw-db.de/",
      },
    ],
    skills: [
      skills.react,
      skills.bootstrap,
      skills.node,
      skills.express,
      skills.mongo,
      skills.firebase,
      skills.ec2,
      skills.route53,
    ],
    images: [
      "/assets/projects/blutwerte-1.jpeg",
      "/assets/projects/blutwerte-2.jpeg",
    ],
  },
  {
    slug: "powerskaters",
    name: "Powerskaters",
    image: "/assets/projects/powerskaters-2.jpeg",
    description: "A stride enhancement system for power skaters",
    details: [
      "Built an engaging user interface using React and Redux Toolkit to enhance user experience",
      "Implemented offline functionality by transforming the application into a Progressive Web App (PWA)",
      "Designed and implemented UI components using React and Redux Toolkit, paying meticulous attention to detail for a visually appealing and intuitive UI",
      "Implemented offline functionality using the latest web technologies and best practices to ensure smooth user experience even when offline",
      "Showcased expertise in UI development with React and Redux Toolkit, as well as advanced web functionalities such as PWAs",
      "Contributed to the development of the stride enhancement system and its positive impact on user experience and functionality of the application",
    ],
    skills: [skills.react, skills.bootstrap],
    images: [
      "/assets/projects/powerskaters-1.jpeg",
      "/assets/projects/powerskaters-2.jpeg",
    ],
  },
  {
    slug: "fabworks",
    name: "Fabworks",
    image: "/assets/projects/fabworks-1.jpeg",
    description:
      "Fabworks is an online platform for precision sheet metal parts with instant pricing and rapid lead-times.",
    details: [
      "Implemented DXF CAD file rendering using three.js, a JavaScript library for 3D graphics programming",
      "Developed custom algorithms to calculate area, cut length, and cut count of entities",
      "Collaborated with team members to integrate rendering capabilities with other parts of the application",
      "Ensured visually appealing and interactive CAD file rendering for enhanced user experience",
      "Paid meticulous attention to detail for precise rendering of entities",
      "Worked on various features and functionalities to improve the overall platform",
    ],
    links: [
      {
        name: "Link",
        url: "https://www.fabworks.com/",
      },
    ],
    skills: [skills.react, skills.threejs],
    images: ["/assets/projects/fabworks-1.jpeg"],
  },
  {
    slug: "fulfillment",
    name: "Shopify Fulfillment App",
    image: "/assets/projects/fulfillment-1.jpeg",
    description:
      "Shopify Fulfillment App is a private Shopify app that offers dynamic solutions for multiple suppliers and warehouses to collaborate on a single platform.",
    details: [
      "Developed new features such as product and order importing/exporting",
      "Implemented order assignment logic based on factors like stock availability, supplier/warehouse proximity, and other complex conditions",
      "Worked on a highly dynamic solution with multiple complex use cases for admin, suppliers, and warehouses",
      "Collaborated with the team to ensure smooth integration with existing Shopify functionalities",
      "Conducted thorough testing and debugging to ensure optimal performance and functionality",
    ],
    links: [
      {
        name: "Link",
        url: "https://dpak.toasterhome.com/",
      },
    ],
    skills: [skills.react, skills.shopify, skills.graphql],
    images: [
      "/assets/projects/fulfillment-1.jpeg",
      "/assets/projects/fulfillment-2.jpeg",
    ],
  },
];

// Featured projects for the AI agent persona (src/index.ts) — the first five,
// name and description only. Derived so it never drifts from `projects`.
export const projectSummaries = projects
  .slice(0, 5)
  .map(({ name, description }) => ({ name, description }));
